export default [
    {
        path: '/signatures/configurations',
        name: 'signatures-configurations',
        component: () => import ('./views/ConfigurationIndex'),
        meta: {
            title: 'Configurações das assinaturas',
            icon: 'mdi-cogs',
            breadcrumbs: [
                { text: 'Lista de configurações', disabled: true }
            ]
        }
    },
]